// Create Event used to offer four stock Unsplash photos and pre-select one as
// every new event's cover. It no longer does, but events made then still carry
// one; those count as "no photo of the host's own", so the dashboard shows the
// template's art for them instead.
const STOCK_COVER = /^https?:\/\/images\.unsplash\.com\//i

/** The host's own cover photo, or null when there is none or it is a stock one. */
export const ownCover = (url?: string | null) => (url && !STOCK_COVER.test(url) ? url : null)
